/* Second Fire Jewelry — theme interactions */
(function () {
  'use strict';

  /* ---- Drawer open/close (cart + mobile menu) ---- */
  function openDrawer(id) {
    var d = document.getElementById(id);
    var o = document.getElementById('DrawerOverlay');
    if (d) d.classList.add('is-open');
    if (o) o.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawers() {
    document.querySelectorAll('.drawer').forEach(function (d) { d.classList.remove('is-open'); });
    var o = document.getElementById('DrawerOverlay');
    if (o) o.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) { e.preventDefault(); openDrawer(open.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.id === 'DrawerOverlay') closeDrawers();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---- Cart: fetch & render in drawer ---- */
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function renderCart(cart) {
    var body = document.getElementById('CartDrawerBody');
    var count = document.querySelectorAll('[data-cart-count]');
    count.forEach(function (c) { c.textContent = cart.item_count; c.classList.toggle('hidden', cart.item_count === 0); });
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty-state"><p class="lead">Your cart is empty.</p><a class="btn btn--ghost" href="/collections/all">Shop the collection</a></div>';
      return;
    }
    var html = '';
    cart.items.forEach(function (it) {
      html += '<div class="cart-line">' +
        '<img src="' + (it.image ? it.image.replace(/(\.[^.]+)$/, '_120x$1') : '') + '" alt="' + it.product_title + '">' +
        '<div><div class="product-card__title" style="font-size:1.1rem">' + it.product_title + '</div>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="product-card__vendor">' + it.variant_title + '</div>' : '') +
        '<div class="price" style="margin-top:8px">' + money(it.final_price) + ' &middot; Qty ' + it.quantity + '</div>' +
        '<button class="link-underline" style="border:none;background:none;margin-top:8px;color:var(--text-muted)" data-cart-remove="' + it.key + '">Remove</button></div>' +
        '<div class="price">' + money(it.final_line_price) + '</div></div>';
    });
    html += '<div style="margin-top:24px"><div class="cart-summary__row cart-summary__total"><span>Total</span><span>' + money(cart.total_price) + '</span></div>' +
      '<a class="btn btn--gold" style="width:100%;margin-top:16px" href="/checkout">Checkout</a>' +
      '<a class="link-underline" style="display:inline-block;margin-top:18px" href="/cart">View cart</a></div>';
    body.innerHTML = html;
  }
  function refreshCart(open) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      renderCart(c); if (open) openDrawer('CartDrawer');
    });
  }
  // Add to cart (AJAX)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCart(true); })
      .catch(function () {})
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: rm.getAttribute('data-cart-remove'), quantity: 0 })
    }).then(function (r) { return r.json(); }).then(renderCart);
  });
  if (document.getElementById('CartDrawer')) refreshCart(false);

  /* ---- Product gallery thumbnails ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.product__thumb');
    if (!t) return;
    var main = document.getElementById('ProductMainImage');
    if (main) main.src = t.getAttribute('data-full');
    document.querySelectorAll('.product__thumb').forEach(function (x) { x.classList.remove('is-active'); });
    t.classList.add('is-active');
  });

  /* ---- Quantity stepper ---- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty]');
    if (!step) return;
    var input = step.parentElement.querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    val += step.getAttribute('data-qty') === 'up' ? 1 : -1;
    input.value = Math.max(1, val);
  });

  /* ---- Accordion ---- */
  document.addEventListener('click', function (e) {
    var h = e.target.closest('.accordion__head');
    if (!h) return;
    h.parentElement.classList.toggle('is-open');
  });

  /* ---- Collection sort ---- */
  var sort = document.getElementById('SortBy');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', this.value);
    window.location.href = u.toString();
  });

  /* ---- Scroll reveal ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }
})();
